import * as recommendedCartService from '/source/js/services/recommendedCartService';
import {
    showSpinner,
    hideSpinner
} from '/source/_patterns/01-components/spinner/spinner';
import productPreview from '/source/_patterns/01-components/product/partials/productPreview.hbs';
import * as modalUtil from '/source/js/utils/modal/modalUtil';
import * as toast from '/source/js/utils/toastUtil';
import manageCartCardsTemplate from '/source/_patterns/01-components/manage-cart/manage-cart-card.hbs';
import allFlowManageCartCardsTemplate from '/source/_patterns/01-components/manage-cart/all-flow-manage-cart-card.hbs';
import { setDataForAllProducts, productDetails } from '/source/js/gtm/IsaGtmCommerce';
import { showPackContents } from '/source/_patterns/01-components/bp-modals/showPackContents';
import { getToastMessage} from '../checkout/checkout-shared';
import * as cartService from '/source/js/services/cartService';

let $manageCartList;
let productData;
const PRODUCT_BUNDLE = 'ProductBundle';
const ASSISTED_ENROLLMENT_REC_CART_ACTION = 'AssistedEnrollmentUsingRecCart';
const RECOMMENDED_CART_ACTION = 'RecommendedCart';
const RECOMMENDED_CART_SEARCH_TYPE = 100;
const RECOMMENDED_CART_SORT_TYPE = 200;
const ERROR_TOAST_EXPIRATION_MS = 3000;
let maxNumSlides = 1;
let prevIcon = `
    <button type="button" class="slick-prev custom-prev-arrow" aria-label='Previous'>
        <i class="fas fa-circle-arrow-left"></i>
    </button>`;
let nextIcon = `
    <button type="button" class="slick-next custom-next-arrow" aria-label='Next'>
        <i class="fas fa-circle-arrow-right"></i>
    </button>`;

async function setRecommendedCartShoppingContext(flow, market, orderSubtype, action) {
    let request = {
        Market: market,
        OrderFlow: flow,
        OrderSubType: orderSubtype,
        Action: action
    };

    try {
        console.log(
            'recommendedCartService.setShoppingContext(request) => request=',
            request
        );
        const result = await recommendedCartService.setShoppingContextUrl(request);

        if(result) {
            console.log('Redirect Url:', result);
        }
    } catch (ex) {
        console.log('error while settingup the shopping context:', ex);
    }
}

async function getProductPreview(productId, culture, country, sku, url) {
    let request = {
        productId,
        culture,
        country,
        sku,
        url
    };
    showSpinner('loading product preview started');
    try {
        console.log(
            'recommendedCartService.getProductPreview(request) => request=',
            request
        );
        const result = await recommendedCartService.getProductPreview(request);
        if(result) {
            productData = result;
            if(productData !== undefined) {
                let modalId = '#product-' + productId;
                if(!$(modalId).hasClass('show')) {
                    $(modalId).addClass('show');
                    $(modalId).addClass('d-block');
                }
                renderQuickPreview(productId);
            }
        }
    } catch (ex) {
        console.log('error while getting Product Details:', ex);
    }
    hideSpinner('loading product preview completed');
}

async function loadRecommendedCart() {
    let $this = $(this);
    let $isView = false;
    let $isDuplicate = false;
    let $isEdit = false;
    if($this.hasClass('view-recommended-cart')) {
        $isView = true;
    }
    if($this.hasClass('duplicate-recommended-cart')) {
        $isDuplicate = true;
    }
    if($this.hasClass('edit-recommended-cart')) {
        $isEdit = true;
    }
    let $rcContainer = $this.closest('.manageCart__container');
    showSpinner('loading recommended cart started');
    let request = null;
    if($rcContainer.length > 0) {
        request = {
            RecommendedCartId: $rcContainer.data('recommended-cart-id'),
            ShareCode: $rcContainer.data('recommended-cart-code'),
            Market: $rcContainer.data('recommended-cart-market'),
            IsView: $isView,
            IsDuplicate: $isDuplicate,
            IsEdit: $isEdit
        };
    } else if($('#recommendedCartId').val() != null) {
        request = {
            RecommendedCartId: $('#recommendedCartId').val(),
            ShareCode: $('#recommendedCartShareCode').val(),
            Market: $('#recommendedCartMarket').val(),
            HasDelegate: $('#placementHasDelegate').val(),
            IsView: $isView,
            IsDuplicate: $isDuplicate
        };
    }
    if(request != null) {
        const result = await recommendedCartService.loadRecommendedCart(request);
        if(result && result.IsSuccessful) {
            window.location.href = result.RedirectPageUrl;
        }
    }
    hideSpinner('loading recommended cart completed');
}

async function updateShareLinkIsFavorite() {
    let $this = $(this);
    let $favIcon = $this;
    let $updateFavoriteRCErrorMessage = $('#updateFavoriteRCErrorMessage').val();
    const IS_ACTIVE = 'is-active';

    if($favIcon.length === 0) return;

    // marked as favorite right now
    let isCurrentlyFavorite = $favIcon.hasClass('is-active');

    let $rcContainer = $this.closest('.manageCart__container');
    showSpinner('updating favorite status started');
    let request = null;
    if($rcContainer.length > 0) {
        // send opposite of isCurrentlyFavorite
        // if true, then false and vice versa
        request = {
            ShareLinkId: $rcContainer.data('recommended-cart-id'),
            IsFavorite: !isCurrentlyFavorite
        };
    }

    if(request != null) {
        const result = await recommendedCartService.updateShareLinkIsFavorite(
            request
        );
        if(result && result.IsSuccessful) {
            $favIcon.toggleClass(IS_ACTIVE, !isCurrentlyFavorite);
        } else {
            toast.Error($updateFavoriteRCErrorMessage, ERROR_TOAST_EXPIRATION_MS);
        }
    }
    hideSpinner('updating favorite status completed');
}

function renderQuickPreview(productId) {
    let modalId = '#product-' + productId;
    let modalContent = $(modalId).find('.isa-modal__content');
    let { ImageCarousel, ReviewCount } = productData;
    if(ReviewCount === '0') {
        productData = { ...productData, ReviewCount: '' };
    }
    let imgHtml = productPreview(productData);
    $(modalContent).empty();
    $(modalContent).append(imgHtml);
    initSlickCarousel(productId);
    $('body').addClass('overflow-hidden');
    if(ImageCarousel !== undefined && ImageCarousel.length < 2) {
        let slickDotsElement = $(modalId).find('.slick-dots');
        slickDotsElement.css('display', 'none');
    } else {
        let maxElements = ImageCarousel.length;
        console.log('maxElements:', maxElements);
        if(maxElements !== undefined && maxElements > 1) {
            maxNumSlides = maxElements;
            let parent = $(modalId);
            disableLeftArrow(parent);
        }
    }
}

async function continueCreateRecommendedCart() {
    await createRecommendedCart();
}

async function createRecommendedCart() {
    let market = $('#recommendedCart-market').val();
    let orderSubtype = $('#recommendedCart-ordersubtype').val();
    if(market && orderSubtype) {
        let request = {
            Market: market,
            OrderSubType: orderSubtype,
            Action: RECOMMENDED_CART_ACTION,
            ShouldResetEnrollmentPlacementData: true
        };
        try {
            showSpinner('setting up shopping context for recommended cart started');
            const result = await recommendedCartService.setShoppingContextUrl(
                request
            );
            hideSpinner('setting up shopping context for recommended cart completed');
            if(result) {
                window.location.href = result;
            }
        } catch (ex) {
            hideSpinner('setting up shopping context for recommended cart completed with errors');
            console.log('Error setting up shopping context for RC:', ex);
        }
    }
}

function initializeRecommendedCart() {
    let market = $('#recommendedCart-market').val();
    let flow = $('#recommendedCart-orderflow').val();
    let orderSubtype = $('#recommendedCart-ordersubtype').val();
    let action = $('#recommendedCart-action').val();
    if(market !== undefined && flow !== undefined && orderSubtype !== undefined && action !== undefined) {
        if(window.sessionStorage.getItem('cultureChanged') === 'true') {
            window.sessionStorage.removeItem('cultureChanged');
            return;
        }
        setRecommendedCartShoppingContext(flow, market, orderSubtype, action);
    }
}

async function loadReviewMyOrder() {
    let element = $(this).find('a');
    if($(this).hasClass('disabled')) {
        return false;
    }
    let cartIdPrefix = $('#recommendedCart-prefix').val();
    let cartType = parseInt($('#recommendedCart-carttype').val()) || 0;
    let shareCode = $('#recommendedCart-sharecode').val();
    let shareType = $('#recommendedCart-sharetype').val();
    let userId = $('#recommendedCart-userid').val();

    let request = {
        CartType: cartType,
        UserId: userId,
        ShareCode: shareCode,
        ShareType: shareType,
        CartIdPrefix: cartIdPrefix,
        IsOrderFlow: true
    };

    $(this).addClass('disabled');
    $(element).addClass('disabled');
    showSpinner('loading order started');
    try {
        console.log(
            'recommendedCartService.GetRecommendedCart(request) => request=',
            request
        );
        const result = await recommendedCartService.GetShareLinkCart(request);
        if(result) {
            if(shareType === PRODUCT_BUNDLE) {
                try {
                    const rawValue = $('#availableProductsInDestinationMarket').val();
                    const parsedProducts = JSON.parse(rawValue);
                    const bundleAlternateProductInfo = {
                        BundleAlternateProducts: parsedProducts
                    };

                    await cartService.addMultipleProductsToCart(bundleAlternateProductInfo);
                } catch (ex) {
                    console.log('error while add availableremaining products to cart', ex);
                }
            }
            console.log('Redirect Url:', result);
            window.location = result;
            console.log(result);
        } else {
            console.log('RC redirect No Result');
        }
    } catch (ex) {
        console.log('error while calling the GetRecommendedCart', ex);
    }
    hideSpinner('loading order completed');
}

function loadPreview() {
    let parent = $(this).parent();
    let culture = $(parent).attr('data-culture');
    let country = $(parent).attr('data-market');
    let productId = $(parent).attr('data-productid');
    let sku = $(parent).attr('data-sku');
    let url = $(parent).attr('data-url');
    getProductPreview(productId, culture, country, sku, url);
}

function closeModal() {
    let idValue = $(this).closest('div.generic-modal').attr('id');
    let id = '#' + idValue;
    if($(id).hasClass('show') && $(id).hasClass('d-block')) {
        $(id).removeClass('show');
        $(id).removeClass('d-block');
    }
    $('body').removeClass('overflow-hidden');
}

function showOrHideLabelForRecommendedCartSummaryInput() {
    let $this = $(this);
    const $recommendedCartInputLabel = $('.recommendedCart__input-label');
    if($this.val() === '') {
        $recommendedCartInputLabel.removeClass('is--active');
    } else {
        $('.recommendedCart__input-label').show().addClass('is--active');
    }
}

async function validateRecommendedCartProducts(event) {
    try {
        let $currentTarget = $(event.currentTarget);
        let $cartContainer = $currentTarget.closest('.manageCart__container');
        let action = $currentTarget.data('recommended-cart-action');

        // data attributes are used on recommendedcartsetup/home
        // hidden fields are used on review page
        let shareCode = $cartContainer.data('recommended-cart-code') || $('#recommendedCartShareCode').val();
        let recommendedCartId = $cartContainer.data('recommended-cart-id') || $('#recommendedCartId').val();
        let cartName = $cartContainer.data('recommended-cart-name') || $('#recommendedCartName').val();
        let rcDetails = $cartContainer.data('rc-details') || JSON.parse($('#rc-details').val());

        let request = {
            shareCode,
            action,
            recommendedCartId
        };
        showSpinner('validating cart products started');
        let result = await recommendedCartService.validateRecommendedCartProducts(request);
        if(!result.IsSuccessful) {
            hideSpinner('validating cart products completed with errors');
            let modalData = $('[data-validate-recommended-cart-error-modal]').data(
                'validateRecommendedCartErrorModal'
            );
            modalData.hideCloseButton = false;
            let errorList = '';
            $.each(result.Messages, function () {
                errorList += '<div>' + this.MessageText + '</div>';
            });
            modalData.content = errorList;
            modalUtil.showError(result, modalData, loadRecommendedCart);

            $('#recommendedCartId').val(recommendedCartId);
            $('#recommendedCartShareCode').val(shareCode);
        } else if(action === 'Enroll') {
            let shoppingRequest = {
                Action: ASSISTED_ENROLLMENT_REC_CART_ACTION,
                ShareCode: shareCode
            };
            let shoppingResult = await recommendedCartService.setShoppingContextUrl(
                shoppingRequest
            );
            window.location = shoppingResult;
        } else {
            hideSpinner('validating cart products completed');
            $('#linkCopiedMessage').hide();
            const updatedRCDetails = !result.ShareLinkHeader ? rcDetails : result.ShareLinkHeader;
            showAllFlowsRCModal(result, updatedRCDetails);
            $('.shareRecommendedCartModalBackdrop.modal-backdrop').removeClass('fade').addClass('show').show();
            let $modalShare = $('#modal-popup-share-image');
            $modalShare.addClass('show').show();
            $('#ShareImage').attr('src', result.ShareImage);
            $('#copyLink').val(result.ShareLinkUrl);
            $('.share-cart-title').find('h2').text(cartName);
        }
    } catch (ex) {
        hideSpinner('validating cart products completed with errors');
        console.error(ex);
    }
}

function updateRCCTAActions() {
    const totalItemCount = $('.manageCart__items').length;
    let $selectedItems = $('.rc-item-selection').filter('input:checked');
    const selectedItemCount = $selectedItems.length;
    const recommendedCarts = [];
    $.each($selectedItems, function () {
        const id = $(this).data('rc-id');
        recommendedCarts.push(id);
    });
    $('#delete-multi-rc-hdn').val(recommendedCarts);
    updateSelectedItems(selectedItemCount);

    if(selectedItemCount === totalItemCount && selectedItemCount > 0) {
        $('.selected-all-rc-items').prop('checked', true);
        $('.delete-rc-cta').prop('disabled', false);
    } else if(selectedItemCount > 0) {
        $('.delete-rc-cart-check').addClass('d-none');
        $('.delete-rc-cart-hyphen').removeClass('d-none');
        $('.selected-all-rc-items').prop('checked', true);
        $('.delete-rc-cta').prop('disabled', false);
    } else if(selectedItemCount === 0) {
        $('.selected-all-rc-items').prop('checked', false);
        $('.delete-rc-cta').prop('disabled', true);
        $('.delete-rc-cart-check').removeClass('d-none');
        $('.delete-rc-cart-hyphen').addClass('d-none');
    }
}

function selectAllRCItems() {
    const $this = $(this);
    $this.prop('indeterminate', false);

    $('body').off('click', '.rc-item-selection', updateRCCTAActions);
    const isChecked = $this.prop('checked');
    $('.rc-item-selection').prop('checked', isChecked);
    $('body').on('click', '.rc-item-selection', updateRCCTAActions);

    let $selectedItems = $('.rc-item-selection').filter('input:checked');
    const selectedItemCount = $selectedItems.length;
    const recommendedCarts = [];
    $.each($selectedItems, function () {
        const id = $(this).data('rc-id');
        recommendedCarts.push(id);
    });
    $('#delete-multi-rc-hdn').val(recommendedCarts);
    $('.delete-rc-cart-check').removeClass('d-none');
    $('.delete-rc-cart-hyphen').addClass('d-none');
    updateSelectedItems(selectedItemCount);
    if(isChecked) {
        $('.delete-rc-cta').prop('disabled', false);
    } else {
        $('.delete-rc-cta').prop('disabled', true);
    }
}

function updateSelectedItems(selectedItemCount) {
    $('.rc-selected-number').text(selectedItemCount);
}

async function deleteSelectedRecommendedCarts() {
    try {
        const selectedItems = $('.rc-item-selection').filter('input:checked');
        const selectedItemCount = $('.rc-item-selection').filter('input:checked').length;
        updateSelectedItems(selectedItemCount);
        const recommendedCarts = [];
        $.each(selectedItems, function () {
            const id = $(this).data('rc-id');
            recommendedCarts.push({ RecommendedCartId: String(id) });
        });
        $('#delete-multi-rc-hdn').val(recommendedCarts);
        let request = {
            RecommendedCarts: recommendedCarts
        };
        showSpinner('deleting selected carts started');
        let result = await recommendedCartService.bulkDeleteRecommendedCart(request);
        if(result && result.IsSuccessful) {
            hideSpinner('deleting selected carts completed');
            window.location.reload();
        } else {
            toast.Error(getToastMessage(result), ERROR_TOAST_EXPIRATION_MS);
            hideSpinner('deleting selected carts completed with errors');
            console.error(result);
        }
    } catch (ex) {
        hideSpinner('deleting selected carts completed with errors');
        console.error(ex);
    }
}

function showAllFlowsRCModal(data, rcDetails) {
    if(data.IsSuccessful && rcDetails) {
        $('.share-reco-modal__content__banner img').attr('src', data.ShareImage);
        $('.member-name').text(rcDetails.ShareName);
        $('.member-type span').text(rcDetails.EnrollingMemberType);
        $('.member-country span').text(rcDetails.Market);
        $('.enrolling-sponser span').text(rcDetails.EnrollingSponsorDisplayName);
        $('.placement-sponser span').text(rcDetails.PlacementSponsorDisplayName);
        $('.link-input').val(data.ShareLinkUrl);

        if(rcDetails.HasPlacementDelegate) {
            $('.placement').hide();
            $('.placement span').text('');
            $('.placement-sponser span').text(rcDetails.PlacementDelegateText);
        } else {
            $('.placement span').text(rcDetails.PlacementPosition);
            $('.placement').show();
        }

        const $frequency = $('.order-frequency');
        let frequency = rcDetails.Frequency;
        if(!frequency) {
            frequency = $('.cart-sidebar__frequecy').data('subscription-frequency');
        }
        if(frequency) {
            const $span = $frequency.find('span');
            let displayText = $span.data('label').replace('###', frequency);
            $span.text(displayText);
            $frequency.show();
        } else {
            $frequency.hide();
        }
    }
}

function showDeleteSelectedRecommendedCarts() {
    $('.confirmDeleteRecommendedCartModalBackdrop.modal-backdrop').removeClass('fade')
        .addClass('show')
        .show();
}

function hideDeleteConfirmationModal() {
    $('#deleteRecommendedModal').hide();
}

async function showDeleteRecommendedCart(event) {
    try {
        let modalData = $('[data-delete-recommended-cart-confirm-modal]').data('deleteRecommendedCartConfirmModal');
        modalData.hideCloseButton = false;
        let $currentTarget = $(event.currentTarget);
        let $cartContainer = $currentTarget.closest('.manageCart__container');
        let cartId = $cartContainer.data('recommended-cart-id') || $('#recommendedCartId').val();
        modalUtil.showConfirmModal(modalData, () => {
            deleteRecommendedCart(cartId);
        });
    } catch (ex) {
        hideSpinner('deleting cart completed with errors');
        console.error(ex);
    }
}
async function deleteRecommendedCart(recommendedCartId) {
    try {
        let request = {
            RecommendedCartId: recommendedCartId
        };
        showSpinner('deleting cart started');
        modalUtil.closeModalById(modalUtil.MODAL_CONFIRM_ID);
        let result = await recommendedCartService.deleteRecommendedCart(request);
        if(!result.IsSuccessful) {
            hideSpinner('deleting cart completed with errors');
            let modalData = $('[data-validate-recommended-cart-error-modal-fail]').data('validateRecommendedCartErrorModalFail');

            modalData.hideCloseButton = false;
            let errorList = '';
            $.each(result.Messages, function () {
                errorList += '<div>' + this.MessageText + '</div>';
            });
            modalData.content = errorList;
            modalUtil.showError(result, modalData, loadRecommendedCart);
        } else {
            if($('#isReviewPage').val() === 'true') {
                window.location = result.RedirectPageUrl;
            } else {
                hideSpinner('deleting cart completed');
                let divToRemove = $(`#Recommended-Cart-${recommendedCartId}`);
                divToRemove.remove();
            }
        }
    } catch (ex) {
        hideSpinner('deleting cart completed with errors');
        console.error(ex);
    }
}

function copyShareLink() {
    let copyText = document.getElementById('copyLink');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand('copy');
    $('#linkCopiedMessage').show();
}

function closeRCModals() {
    $('cartModal').hide();
    $('.copy-success').hide();
    $('#linkCopiedMessage').hide();
    $('.modal-backdrop').removeClass('show').hide();
    $('#modal-popup-share-image').removeClass('show').hide();
    $('#modal-popup-error').removeClass('show').hide();
}

function initEventHandlers() {
    let skipModal = $('.manageCart__list').children('.manageCart__items').length > 0;
    $('#recommended-cart-cta').on('click', loadReviewMyOrder);
    $('.recommended-carts-products-cta').on('click', loadPreview);
    $('.recommendedCart__input').on('input', showOrHideLabelForRecommendedCartSummaryInput);
    $('.recommended-cart-close').on('click', closeModal);
    $('.edit-recommended-cart').on('click', loadRecommendedCart);
    $('.view-recommended-cart').on('click', loadRecommendedCart);
    $('.duplicate-recommended-cart').on('click', loadRecommendedCart);
    $('.recommended-cart-validate').on('click', validateRecommendedCartProducts);
    $('.delete-recommended-cart').on('click', showDeleteRecommendedCart);
    $('.delete-rc-cta').on('click', showDeleteSelectedRecommendedCarts);
    $('#btnCopyLink').on('click', copyShareLink);
    $('.dismissModal').on('click', closeRCModals);
    $('.recommended-cart-search-close').on('click', clearSearchField);

    $('.create-recommendedCart-btn').on('click', createRecommendedCart.bind(this, { skipModal }));
    $('.continue-create-recommendedCart-btn').on('click', continueCreateRecommendedCart);
    $('.recommended-cart-filter').click(loadRecommendedCartFilterResults);
    $('.recommended-cart-Sort').change(loadRecommendedCartFilterResults);
    $('.recommended-cart-search').click(loadRecommendedCartFilterResults);
    $('#recommended-cart-search-input').keydown(onSearchTyping);
    $('body').on('click', '.fav-btn', updateShareLinkIsFavorite);
    $('body').on('click', '.rc-item-selection', updateRCCTAActions);
    $('body').on('click', '.selected-all-rc-items', selectAllRCItems);
    $('.cancel-delete-btn').on('click', hideDeleteConfirmationModal);
    $('.confirm-delete-btn').on('click', deleteSelectedRecommendedCarts);
    $manageCartList = $('.manageCart__section');

    $(document).on('click', '.recommended-carts__Products-row .view-pack-contents', showPackContents);
}

function addGtmTagToProductView() {
    if(!window.ga_props || window.ga_props.length === 0) {
        return;
    }

    let lastEvent = window.ga_props[window.ga_props.length - 1];
    if(!lastEvent) return;
    var memberId = lastEvent.MemberId;
    var memberType = lastEvent.MemberType;
    var currency = lastEvent.Currency;
    var cultureCode = lastEvent.CultureCode;
    var catalog = lastEvent.CatalogName;
    let category;
    let marketingCloudUserId;
    let hasProducts = lastEvent.Products && lastEvent.Products.length > 0;
    if(hasProducts) {
        category = lastEvent.Products[0].ProductFamilyName;
        marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
    }
    var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
    var preferredCultureCode = lastEvent.PreferredCultureCode;
    var hasAutoship = lastEvent.HasAutoship;
    var canEnroll = lastEvent.CanEnroll;
    var hasIsaDelivery = lastEvent.HasIsaDelivery;
    var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
    var products = [];

    if(hasProducts) {
        if(Array.isArray(lastEvent.Products) && lastEvent.Products.length > 0) {
            lastEvent.Products.forEach(product => {
                products.push({
                    'name': product.ProductName,
                    'id': product.Sku,
                    'price': product.Price,
                    'brand': product.Brand,
                    'category': product.ProductFamilyName,
                    'quantity': product.Quantity
                });
            });

            console.log(products);
        }
    }

    productDetails(products);
}

function clearSearchField() {
    $('#recommended-cart-search-input').val('');
    $('.recommended-cart-search-close').addClass('d-none');
    $('.recommended-cart-search').removeClass('d-none');
    loadRecommendedCartFilterResults();
}

function createPayload(form) {
    let searchText = $('#recommended-cart-search-input').val();
    let sortText = $('#orderSelected').find(':selected').val();

    let payload = [];
    if(searchText) {
        payload.push({
            searchType: RECOMMENDED_CART_SEARCH_TYPE,
            value: searchText
        });
    }
    if(sortText) {
        payload.push({ searchType: RECOMMENDED_CART_SORT_TYPE, value: sortText });
    }

    for (var i = 0; i < form.length; i++) {
        let name = form[i].name;
        let index = name.indexOf('t');
        let facet = name.slice(index + 1, index + 2);
        let value = name.slice(index + 7);
        payload.push({ searchType: facet, value: value });
    }
    return payload;
}

async function loadRecommendedCartFilterResults() {
    const form = $('#recommended-cart-filter-form').serializeArray();
    var payload = createPayload(form);
    try {
        console.log('recommendedCartService.GetManageCart(request) => request=', payload);
        showSpinner('loading cart filter results started');
        const result = await recommendedCartService.GetManageCart(payload);
        hideSpinner('loading cart filter results completed');
        if(result) {
            console.log('GetManageCart Sucessfull');
            UpdateResults(result);
        } else {
            console.log('GetManageCart Fail');
        }
    } catch (ex) {
        console.log('error while calling the GetManageCart', ex);
    }
}

function onSearchTyping(event) {
    if($('#recommended-cart-search-input').val()) {
        $('.recommended-cart-search-close').removeClass('d-none');
        $('.recommended-cart-search').addClass('d-none');
    } else {
        $('.recommended-cart-search-close').addClass('d-none');
        $('.recommended-cart-search').removeClass('d-none');
    }
    if(event.which === 13) {
        event.preventDefault();
        loadRecommendedCartFilterResults();
    }
}

function UpdateResults(result) {
    console.log(result);
    $manageCartList.empty();
    if(result.ShareLinkHeaderInformationModel.ShareLinkHeaders.length === 0) {
        let noResultsMessage = $('#recommendedCartNoResults').val();
        let selectedDiv = `<div class="manageCart__list"> <p class="manageCart__error">${noResultsMessage}</p></div>`;
        $manageCartList.append(selectedDiv);
        $('#delete-multi-rc').prop('checked', false);
        $('.delete-multi-recommended-cart').prop('disabled', true);
        $('#delete-multi-rc').prop('disabled', true);
        $('.rc-selected-number').text('0');
        return;
    }

    result.ShareLinkHeaderInformationModel.ShareLinkHeaders.forEach((element) => {
        element.ShareLinkHeaderJson = JSON.stringify(element);
        let $selectedRCItems = $('#delete-multi-rc-hdn').val();
        if($selectedRCItems.indexOf(element.ShareLinkId) > -1) {
            element.rcSelected = true;
        } else {
            element.rcSelected = false;
        }
    });

    let manageCartCardsHtml;
    if(result.IsManageRCEnabled) {
        manageCartCardsHtml = allFlowManageCartCardsTemplate(
            result.ShareLinkHeaderInformationModel
        );
    } else {
        manageCartCardsHtml = manageCartCardsTemplate(
            result.ShareLinkHeaderInformationModel
        );
    }
    $manageCartList.html(manageCartCardsHtml);
    $('.edit-recommended-cart').on('click', loadRecommendedCart);
    $('.view-recommended-cart').on('click', loadRecommendedCart);
    $('.duplicate-recommended-cart').on('click', loadRecommendedCart);
    $('.delete-recommended-cart').on('click', showDeleteRecommendedCart);
    $('.recommended-cart-validate').on('click', validateRecommendedCartProducts);
    $('body').on('click', '.fav-btn', updateShareLinkIsFavorite);
    const selectedItemCount = $('.rc-item-selection').filter('input:checked').length;
    updateSelectedItems(selectedItemCount);
    if(selectedItemCount > 0) {
        $('#delete-multi-rc').prop('checked', true);
        $('.delete-multi-recommended-cart').prop('disabled', false);
        $('#delete-multi-rc').prop('disabled', false);
    } else {
        $('#delete-multi-rc').prop('checked', false);
        $('.delete-multi-recommended-cart').prop('disabled', true);
    }
}

function initSlickCarousel(productid) {
    if(productid === undefined) {
        $('.rc-preview-modal .product-gallery__main').slick({
            arrows: true,
            dots: true,
            autoplaySpeed: 1000,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    } else {
        let modalId = '#product-' + productid;
        let imgContainer = $(modalId).find(
            '.product-gallery__container .product-gallery__main'
        );
        $(imgContainer).slick({
            arrows: true,
            dots: true,
            autoplaySpeed: 1000,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: prevIcon,
            nextArrow: nextIcon
        });
    }
}

function handleArrowClick() {
    let id = $(this).closest('div.rc-preview-modal').attr('id');
    let parent = $('#' + id);
    let element = $(parent)
        .find('div.product-gallery__main .slick-current.slick-active')
        .first();
    let index = $(element).attr('data-slick-index');

    enableLeftArrow(parent);
    enableRightArrow(parent);
    if(index !== undefined && index === '0') {
        disableLeftArrow(parent);
        enableRightArrow(parent);
    }
    let numtoStr = (maxNumSlides - 1).toString();
    if(index !== undefined && index === numtoStr) {
        disableRightArrow(parent);
        enableLeftArrow(parent);
    }
}

function disableLeftArrow(parent) {
    let element = $(parent)
        .find('div.product-gallery__main .slick-prev.slick-btn--left')
        .first();
    let img = $(element).find('img');
    let src = img.attr('src');
    if(src !== undefined && !src.includes('-disabled')) {
        let imageNameWithoutExt = src.slice(0, -4);
        let newSrc = imageNameWithoutExt + '-disabled.svg';
        img.attr('src', newSrc);
    }
}

function enableLeftArrow(parent) {
    let element = $(parent)
        .find('div.product-gallery__main .slick-prev.slick-btn--left')
        .first();
    let img = $(element).find('img');
    let src = img.attr('src');
    if(src !== undefined && src.includes('-disabled')) {
        let imageNameWithoutExt = src.slice(0, -13);
        let newSrc = imageNameWithoutExt + '.svg';
        img.attr('src', newSrc);
    }
}

function disableRightArrow(parent) {
    let element = $(parent)
        .find('div.product-gallery__main .slick-next.slick-btn--right')
        .first();
    let img = $(element).find('img');
    let src = img.attr('src');
    if(src !== undefined && !src.includes('-disabled')) {
        let imageNameWithoutExt = src.slice(0, -4);
        let newSrc = imageNameWithoutExt + '-disabled.svg';
        img.attr('src', newSrc);
    }
}

function enableRightArrow(parent) {
    let element = $(parent)
        .find('div.product-gallery__main .slick-next.slick-btn--right')
        .first();
    let img = $(element).find('img');
    let src = img.attr('src');
    if(src !== undefined && src.includes('-disabled')) {
        let imageNameWithoutExt = src.slice(0, -13);
        let newSrc = imageNameWithoutExt + '.svg';
        img.attr('src', newSrc);
    }
}

function initializeSlick() {
    const $slider = $('.rc-products-slider');
    const mediaQuery = window.matchMedia('(max-width: 42.75rem)');
    function handleMediaChange(e) {
        if(e.matches) {
            if(!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    infinite: false,
                    prevArrow: prevIcon,
                    nextArrow: nextIcon
                }).on('setPosition afterChange', function (event, slick) {
                    updateDots(slick);
                });
            }
        } else {
            if($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        }
    }
    mediaQuery.addEventListener('change', handleMediaChange);
    handleMediaChange(mediaQuery);
}

function updateDots(slick) {
    const totalSlides = slick.slideCount;
    const maxDots = 5;
    const $dotsContainer = $('.slick-dots');
    const $dots = $dotsContainer.find('li');
    const currentSlide = slick.currentSlide;

    if(totalSlides <= 1) {
        $dotsContainer.hide(); // Hide dots if only one slide
        return;
    } else {
        $dotsContainer.show(); // Show dots if more than one slide
    }

    $dots.each(function (index) {
        if(index >= maxDots) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });

    $('.slick-dots .extra-indicator').remove();

    if(totalSlides > maxDots) {
        const extraSlides = totalSlides - maxDots;
        const $lastDot = $dots.eq(maxDots - 1);
        $lastDot.after(`<li class="extra-indicator"><span>+${extraSlides}</span></li>`);

        if(currentSlide >= maxDots) {
            $('.slick-dots .extra-indicator').addClass('active');
        } else {
            $('.slick-dots .extra-indicator').removeClass('active');
        }
    }
}

function toggleStickyButton($selector) {
    const stickyElement = $($selector);
    let isSticky = false;

    if(!stickyElement.length) {
        return;
    }

    function handleScroll() {
        const scrollPosition = $(window).scrollTop();
        const adjustedOffsetTop = stickyElement.offset().top + stickyElement.outerHeight() - 25;
        const shouldDisplaySticky = scrollPosition > adjustedOffsetTop;

        if(shouldDisplaySticky && !isSticky) {
            stickyElement.addClass('rc-cta-section-sticky');
            isSticky = true;
        } else if(!shouldDisplaySticky && isSticky) {
            stickyElement.removeClass('rc-cta-section-sticky');
            isSticky = false;
        }
    }

    handleScroll();

    let scrollTimeout;
    $(window).on('scroll', function () {
        if(scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(handleScroll, 100);
    });
}

function adjustSvgVisibility($containerSelector) {
    const cardContainer = $($containerSelector);
    const cards = cardContainer.find('.item-card');

    if(cards.length === 0) {
        return;
    }

    const containerWidth = cardContainer.innerWidth(); // Use innerWidth to include padding
    const cardWidth = cards.first().outerWidth(); // Use outerWidth to include padding and border
    const margin = parseFloat(cards.first().css('margin-left')) + parseFloat(cards.first().css('margin-right'));

    const effectiveCardWidth = cardWidth + margin;
    const cardsPerRow = Math.floor(containerWidth / effectiveCardWidth);

    // Hide all SVGs by default
    cards.each(function() {
        const svg = $(this).find('svg');
        svg.hide();
    });

    // Show SVGs based on the number of cards per row
    cards.each(function(index) {
        const svg = $(this).find('svg');
        if(cardsPerRow === 2 && (index % 2 === 1)) {
            svg.show(); // Show SVG for every second card
        } else if(cardsPerRow === 3 && (index % 3 !== 0)) {
            svg.show(); // Show SVG for the second and third card in every triplet
        } else if(cardsPerRow >= 4 && (index % 4 !== 0)) {
            svg.show(); // Show SVG for the second, third, and fourth card in every quartet
        }
    });
}

$(function () {
    initializeRecommendedCart();
    initEventHandlers();
    toggleStickyButton('.rc-cta-section');
    $(document).on('click', 'div.rc-preview-modal button.slick-arrow', handleArrowClick);
    initializeSlick();
    $(window).resize(function () {
        initializeSlick();
        toggleStickyButton('.rc-cta-section');
        adjustSvgVisibility('.recommended-carts__Products-row');
    });
    $(window).on('load', function() {
        adjustSvgVisibility('.recommended-carts__Products-row');
    });
    addGtmTagToProductView();
});
